<template>
    <section class="py-20 lg:py-28 bg-secondary">
        <div class="container mx-auto px-4">
            <h2 class="text-3xl md:text-4xl font-bold text-center text-foreground mb-4">
                {{ content.title_before }}
                <span v-if="content.title_accent" class="text-gradient-blue">{{ content.title_accent }}</span>
                {{ content.title_after }}
            </h2>
            <p v-if="content.subtitle" class="text-center text-muted-foreground mb-14 max-w-2xl mx-auto">
                {{ content.subtitle }}
            </p>

            <div class="max-w-3xl mx-auto space-y-4">
                <div
                    v-for="(item, i) in items"
                    :key="i"
                    class="flex items-start gap-4 bg-card rounded-xl p-5 border border-border shadow-sm hover:shadow-md transition-shadow"
                >
                    <div
                        class="w-8 h-8 rounded-full bg-accent/15 flex items-center justify-center flex-shrink-0 mt-0.5"
                    >
                        <BlockIcon name="CheckCircle2" class="text-accent" :size="18" />
                    </div>
                    <div>
                        <p v-if="item.before" class="text-muted-foreground text-sm line-through mb-1">
                            {{ item.before }}
                        </p>
                        <p class="text-foreground font-medium">{{ item.after }}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import BlockIcon from "./BlockIcon.vue";

export default {
    name: "NoNeedBlock",
    components: { BlockIcon },
    props: { content: { type: Object, default: () => ({}) } },
    computed: {
        items() {
            return this.content.items || [];
        },
    },
};
</script>
